/**
 * Helpers Functions
 */
import moment from "moment";
import { parse, parseISO } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";

/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      "," +
      alpha +
      ")"
    );
  }
  throw new Error("Bad Hex");
}

/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = "...";
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

/**
 * Get Date
 */
export function getTheDate(timestamp, format) {
  let time = timestamp * 1000;
  let formatDate = format ? format : "MM-DD-YYYY";
  return moment(time).format(formatDate);
}

/**
 * Convert Date To Timestamp
 */
export function convertDateToTimeStamp(date, format) {
  let formatDate = format ? format : "YYYY-MM-DD";
  return moment(date, formatDate).unix();
}

/**
 * Function to return current app layout
 */
export function getAppLayout(url) {
  let location = url.pathname;
  let path = location.split("/");
  return path[1];
}
/**
 * Function to return errors from API
 */
export function getMessageError(object) {
  const keys = Object.keys(object);
  let strErros = "";
  keys.map(key => {
    strErros += object[key] + "\n";
  });
  return strErros;
}

/**
 * Function to return input errors
 */
export function getInputErrors(name, error) {
  return error[name] ? error[name].message : '';
}

export function verifyIfDateIsToday(date) {
  if (!date) return false;
  date = new Date(date);
  if (!(date instanceof Date)) return false;
  if (isNaN(date.getDate())) return false;
  const today = new Date();
  return today.getDate() == date.getDate() &&
    today.getMonth() == date.getMonth() &&
    today.getFullYear() == date.getFullYear();
}

export function compareDate(date1, date2) {
  // if (!date1 || !date2) return;
  // if (!(date1 instanceof Date) || !(date2 instanceof Date)) return;
  // if (isNaN(date1.getDate()) || isNaN(date2.getDate())) return;
  /*
           -1              0              1
      date1 > date2  date1 == date2 date1 < date2
 */
  if (date1 > date2) return -1;
  if (date2 > date1) return 1;
  return 0;
}

export function datesAreSame(date1, date2) {
  if (!date1 || !date2) return null;
  if (!(date1 instanceof Date) || !(date2 instanceof Date)) return null;
  if (isNaN(date1.getDate()) || isNaN(date2.getDate())) return null;

  return date1.getDate() == date2.getDate() &&
    date1.getMonth() == date2.getMonth() &&
    date1.getFullYear() == date2.getFullYear();
}

export function dateAndTimeAreSame(date1, date2) {
  return date1.getTime() == date2.getTime();
}

export function differenceBetweenDates(minDate, maxDate) {
  let valid = true;
  if (!minDate || !maxDate) valid = false;
  // if (!minDate || !maxDate) return null;

  if (!(minDate instanceof Date)) minDate = new Date(minDate);
  if (!(maxDate instanceof Date)) maxDate = new Date(maxDate);

  if (isNaN(minDate.getDate()) || isNaN(maxDate.getDate())) valid = false;
  // if (isNaN(minDate.getDate()) || isNaN(maxDate.getDate())) return null;

  const max = moment(maxDate);
  const min = moment(minDate);
  const d = moment.duration(max.diff(min));

  const seconds = d.asSeconds() % 60 == 0 ? 0 : (d.asSeconds() % 60);
  const minutes = d.asMinutes() % 60 == 0 ? 0 : Number((d.asMinutes() % 60).toString().split('.')[0]);
  const hours = d.asHours() % 24 == 0 ? 0 : Number((d.asHours() % 24).toString().split('.')[0]);
  const days = Number(d.asDays().toString().split('.')[0]);
  const months = Number(d.asMonths().toString().split('.')[0]);
  const years = Number(d.asYears().toString().split('.')[0]);

  return {
    valid,
    seconds,
    minutes,
    hours,
    days,
    months,
    years,
    difference: seconds + minutes + hours + days + months + years
  }
}

export function goToTopPage() {
  const top = document.createElement("a");
  top.setAttribute("href", "#top");
  document.body.appendChild(top);
  top.click();
  top.remove();

  // const mainUrl = document.location.href.split("#")[0];
  // window.history.pushState("redirect to top of page", "Title", mainUrl);
}

export function changeTitlePageByResource(resource) {
  const app = "Shipeezi";
  if (!resource) {
    document.title = app;
    return;
  }
  resource = String(resource);
  let path;
  if (resource.includes('-')) {
    const paths = resource.split('-');
    path = paths[0].substr(0, 1).toUpperCase() + paths[0].substr(1).toLowerCase();
  } else {
    path = resource.substr(0, 1).toUpperCase() + resource.substr(1).toLowerCase();
  }
  const title = `${path} | ${app}`;
  document.title = title;
}

const formatInTimeZone = (date, fmt, tz) =>
  format(utcToZonedTime(date, tz),
    fmt,
    { timeZone: tz });

export function getUtcDate(date) {
  const format = "yyyy-MM-dd kk:mm:ss xxx"
  const parsedTime = parseISO(new Date(date).toISOString());
  return formatInTimeZone(parsedTime, format, "UTC");
}